module.exports = __webpack_public_path__ + "img/insurance_2.f4fc7e5e.png";